export enum eUIActionTypes {
	CLEAR_STATE = 'UI/CLEAR_STATE',
	SET_INITED = 'UI/SET_INITED',
	SET_IS_CHR_REGISTERED = 'UI/SET_IS_CHR_REGISTERED',
	SET_IS_WRONG_NETWORK = 'UI/SET_IS_WRONG_NETWORK',
	SET_IS_ORDER_BOOK_MODAL_BUTTONS_BLOCKED = 'UI/SET_IS_ORDER_BOOK_MODAL_BUTTONS_BLOCKED',
	SET_IS_PRICES_UPDATING = 'UI/SET_IS_PRICES_UPDATING',
	SET_PROVIDER = 'UI/SET_PROVIDER',
}

export type tUIAction =
	iClearStateAction |
	iSetIsInitedAction |
	iSetIsChrRegisteredAction |
	iSetIsWrongNetwork |
	iSetIsOrderBookModalButtonsBlockedAction |
	iSetIsPricesUpdatingAction |
	iSetProvider
;

interface iClearStateAction {
	type: eUIActionTypes.CLEAR_STATE,
}

interface iSetIsInitedAction {
	type: eUIActionTypes.SET_INITED,
}

interface iSetIsChrRegisteredAction {
	type: eUIActionTypes.SET_IS_CHR_REGISTERED,
	payload: boolean
}

interface iSetIsWrongNetwork {
	type: eUIActionTypes.SET_IS_WRONG_NETWORK,
	payload: boolean
}

interface iSetIsOrderBookModalButtonsBlockedAction {
	type: eUIActionTypes.SET_IS_ORDER_BOOK_MODAL_BUTTONS_BLOCKED,
	payload: boolean
}

interface iSetIsPricesUpdatingAction {
	type: eUIActionTypes.SET_IS_PRICES_UPDATING,
	payload: boolean
}

interface iSetProvider {
	type: eUIActionTypes.SET_PROVIDER,
	payload: any
}